import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import { CreateClientService, GetClientService, GetCustomerChatService, UpdateClientService, ValidateClientDataInRealDBService } from '../../services/ClientServices'
import { CreateClientChatService, CreateClientSessionChatService } from '../../services/ClientChatServices'
import { Select } from 'antd'
import { GetSearchService } from '../../services/AuthServices'
import { useSelector } from 'react-redux'
import { CreateClassBookingService, UpdateClassBookingService } from '../../services/class_booking/classBookingServices'
import SettingsMenu from '../staticscreens/SettingsMenu'
import { GetTeacherListService, GetTeacherSearchService } from '../../services/class_booking/TeacherServices'
import { GetFileStandardService } from '../../services/admin/FileStandardServices'
import { GetBookingSlotService } from '../../services/class_booking/bookingSlotServices'

function DemoBookingCE() {

  const roles = useSelector(state=>state.Auth.roles)
  const {state} = useLocation()
  
  const [data, setdata] = useState({section_name: '', teacher: '', student: [],booking_slots:'',class_completed:'',teacher_remarks:'',meet_link:'',classId:''});
  const [error, seterror] = useState({section_name: '', teacher: '', student: '',booking_slots:'',class_completed:'',teacher_remarks:'',meet_link:'',classId:''});

  const [student,setstudent] = useState([])
  const [teacher,setteacher] = useState([])
  const [standard,setstandard] = useState([])
  const [booking_slots,setbooking_slots] = useState([])

  const class_completed_arr = ['Pending','Completed','Cancelled','User Not Joined','Partially Joined']?.map((d)=>({label:d,value:d}))


  const navigate = useNavigate();

  console.log("state",state)


  useEffect(() => {
    if (state?._id !== null && state?._id !== undefined) {

      let d = state 
      let passData = {
        ...d,
        teacher:{label:d?.teacher?.name,value:d?.teacher?._id},
        student:d?.student?.map((s)=>({label:s?.name === '' ? 'No name added' : s?.name,value:s?._id})),
        class_completed:{label:d?.class_completed,value:d?.class_completed},
        classId:{label:d?.class?.label,value:d?.class?._id},
        booking_slots:{label:`${formatTo12Hour(d?.booking_slots?.start_time)} - ${formatTo12Hour(d?.booking_slots?.end_time)}`,value:d?.booking_slots?._id} 
      }
      setstudent(passData?.student)

      setdata(passData)
    
    }

    getFilterData()

  }, [state])
 

  const validationEdit = roles?.includes('admin') || (state?._id !== null && state?._id !== undefined && state?.mode === "Automatic" ? false : true)
  const validationCreate = (state?._id == null || state?._id == undefined)

  async function getFilterData() {
    const response = await GetFileStandardService()
    let arr = [];
    response?.data?.datas?.forEach((d) => {
      arr.push({
        label: d?.label,
        value: d?._id,
      });
    });
    setstandard(arr)
    const response1 = await GetBookingSlotService()
    let arr1 = [];

    response1?.data?.datas?.forEach((d) => {
      arr1.push({
        label: `${formatTo12Hour(d?.start_time)} - ${formatTo12Hour(d?.end_time)}`,
        value: d?._id,
      });
    });

    setbooking_slots(arr1);
  } 
 
 const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12; // convert 0 -> 12
    return `${h}:${minutes} ${ampm}`;
};


  async function handlechange(e) {
    let {name,value} = e.target
    setdata({ ...data, [name]: value })
    seterror({ ...error, [name]: '' })
  }

  async function searchData(val,type){
  
    if(type === 'student'){
      const response = await GetClientService(1, '', '', '','All Data','',val)
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr?.push({label:d?.name === '' ? ('No name added ' + d?.mobile) : d?.name + ' ' + d?.mobile,value:d?._id})
      })
      setstudent(arr)
    }

    if(type === 'teacher'){
      const response = await GetTeacherSearchService(val,1,'Counsellor','')
      let arr = []
      response?.data?.datas?.forEach((d)=>{
        arr?.push({label:d?.name === '' ? ('No name added ' + '[' + d?.type + ']') : d?.name + ' ' + '[' + d?.type + ']',value:d?._id})
      })
      
      setteacher(arr)
    }
    
  }



  async function submitform() {
    if (!data.section_name) {
      seterror({ ...error, section_name: 'This field is required *' })
    }else if (!data.meet_link) {
      seterror({ ...error, meet_link: 'This field is required *' })
    }else {

       if(state?._id == null || state?._id == undefined){
        let sendData = { ...data }
        sendData['booking_slots'] = data?.booking_slots?.value
        sendData['class_completed'] = data?.class_completed?.value
        sendData['teacher'] = data?.teacher?.value
        sendData['student'] = data?.student?.map((s)=>s?.value)
        sendData['classId'] = data?.classId?.value
   
        const response = await CreateClassBookingService(sendData, state?._id)
        if (response.status === 200) {
          navigate(-1)
          toast.success('Class Booking Info Updated Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
    }else{
      let sendData = { ...data }
      sendData['booking_slots'] = data?.booking_slots?.value
      sendData['class_completed'] = data?.class_completed?.value
      sendData['teacher'] = data?.teacher?.value
      sendData['student'] = data?.student?.map((s)=>s?.value)
      sendData['classId'] = data?.classId?.value
 
      sendData["id"] = state?._id

        const response = await UpdateClassBookingService(sendData, state?._id)
        if (response.status === 200) {
          navigate(-1)
          toast.success('Class Booking Info Updated Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
    }
  }
}



  function handleSelect(e, e1) {
    if (e1 === 'student') {
      const arr = e?.map((ele) =>
        student?.find((r) => r?.value === ele) ?? data?.student?.find((s) => s?.value === ele)
      )
      setdata({ ...data, student: arr })
      seterror({ ...error, student: '' })
    } else if (e1 === 'class_completed') {
      setdata({ ...data, class_completed: class_completed_arr?.find((c) => c?.value === e) })
    } else if (e1 === 'teacher') {
      const selected = teacher?.find((t) => t?.value === e)
      if (selected) setdata({ ...data, teacher: selected })
    } else if (e1 === 'classId') {
      const selected = standard?.find((t) => t?.value === e)
      if (selected) setdata({ ...data, classId: selected })
    } else if (e1 === 'booking_slots') {
      const selected = booking_slots?.find((t) => t?.value === e)
      if (selected) setdata({ ...data, booking_slots: selected })
    }
  }
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

   
     
      <div>
        <SettingsMenu />
      </div> 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        <div className='sm:w-full relative lg:w-[300px] px-4 pt-5' >


          <GoBack />

          {/* <AudioRecorder /> */}



          <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} Class Booking Info</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Class Booking details</b> assign to you!.</h6>

          {/* <AudioRecorderComponent /> */}


          <TextInput
            mandatory={true}
            label={'Section Name'}
            variant="standard"
            name="section_name"
            type="text"
            error={error.section_name}
            value={data.section_name}
            handlechange={handlechange}
            placeholder=""
            readOnly={validationCreate ? false : !validationEdit}
            InputLabelProps={{
              style: { color: '#fff', },
            }} />

          
          <div className='relative'>
           {data?.meet_link && (
            <h6
              onClick={() => {
                if (data.meet_link.includes("meet")) {
                  window.open(data.meet_link, "_blank");
                } else {
                  const separator = data.meet_link.includes("?") ? "&" : "?";
                  window.open(
                    `myacademy://join?room=${encodeURIComponent(
                      data.meet_link
                    )}${separator}role=teacher`
                  );
                }
              }}
              className="text-[14px] text-green-600 font-[800] text-[9px] cursor-pointer absolute left-[60px] top-[2px] underline"
            >
              Open Meet
            </h6>
          )}
          <TextInput
            mandatory={true}
            label={'Meet Link'}
            variant="standard"
            name="meet_link"
            type="text"
            readOnly={validationCreate ? false : !validationEdit}
            error={error.meet_link}
            value={data.meet_link}
            readOnly={true}
            // handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />
            </div>  

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Booking Slots </h6>
                <Select
                  value={data.booking_slots} 
                  bordered={false}
                  placeholder="" 
                  disabled={validationCreate ? false : !validationEdit}
                  onChange={(e)=>handleSelect(e,'booking_slots')} 
                  options={booking_slots} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

              {/* <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class </h6>
                <Select
                  value={data.classId} 
                  bordered={false}
                  placeholder="" 
                  disabled={validationCreate ? false : validationEdit}
                  onChange={(e)=>handleSelect(e,'classId')} 
                  options={standard} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div>  */}


            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Teacher Info </h6>
                <Select
                  value={data.teacher} 
                  filterOption={false}
                  showSearch
                  bordered={false}
                  placeholder="" 
                  disabled={validationCreate ? false : !validationEdit}
                  onChange={(e)=>handleSelect(e,'teacher')} 
                  onSearch={(e)=>searchData(e,'teacher')}
                  options={teacher} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 

             <div>
             <h6 className='text-[11px] mb-1 mt-2'>Class Status </h6>
                <Select
                  value={data.class_completed} 
                  filterOption={false}
                  bordered={false}
                  placeholder="" 
                  disabled={validationCreate ? false : !validationEdit}
                  onChange={(e)=>handleSelect(e,'class_completed')} 
                  options={class_completed_arr} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 



            <div>
             <h6 className='text-[11px] mb-1 mt-2'>Students</h6>
                <Select
                  value={data.student} 
                  filterOption={false}
                  bordered={false}
                  showSearch
                  placeholder="" 
                  mode="multiple" 
                  filterOption={false}
                  disabled={validationCreate ? false : !validationEdit}
                  onChange={(e)=>handleSelect(e,'student')} 
                  onSearch={(e)=>searchData(e,'student')}
                  options={student} 
                  className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
      
                  />
            </div> 
  
          <ErrorComponent error={error?.type} /> 

        

          <TextAreaInput1 
          label={'Remarks'}
            variant="standard"
            name="teacher_remarks"
            type="text"
            error={error.teacher_remarks}
            value={data.teacher_remarks}
            handlechange={handlechange}
            placeholder=""
            // readOnly={validationCreate ? false : validationEdit}
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />

           {state?.mode && <h6 className='text-[12px]'>Demo Booking Type : <b>{state?.mode}</b></h6>}

         
        <div className='mt-4 flex'>
       
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>


        </div>
        
       

      
      </div>

      
      </div> 

    </div>
  )
}

export default DemoBookingCE